import { render, staticRenderFns } from "./yimiao.vue?vue&type=template&id=3949817c"
import script from "./yimiao.vue?vue&type=script&lang=js"
export * from "./yimiao.vue?vue&type=script&lang=js"
import style0 from "./yimiao.vue?vue&type=style&index=0&id=3949817c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports